/**
 * Created by Andrey Popov on 29.08.22
 */

const SnailFeastWindow = CleverappsWindow.extend({
    onWindowLoaded: function (mission, { showTooltip } = {}) {
        this.mission = mission;
        this.showTooltip = showTooltip;

        this.bundleName = mission.getWindowBundleName();

        const offer = this.offer = cleverapps.offerManager.findOffer({ mission: this.mission.type });

        this.isVertical = cleverapps.resolution.isVertical();

        this.playerViews = {};
        this.cupIcons = {};

        this._super({
            name: "SnailFeastWindow",
            content: this.createContent(),
            noBackground: true,
            contentPadding: cleverapps.styles.SnailFeastWindow.contentPadding,
            styles: cleverapps.styles.SnailFeastWindow.window,
            openSound: bundles[this.bundleName].urls.snail_window_sfx,
            notCloseByTouchInShadow: true,
            closeButton: !this.slotCloseButton,
            offerWindowButton: offer ? {
                text: Messages.get(`FeastMissionWindow.${this.mission.getName()}.offer`),
                offerType: offer.type,
                onClicked: this.onOfferClicked.bind(this),
                bundle: "snail_feast",
                badgeText: Messages.get(`FeastMissionWindow.${this.mission.getName()}.offerBadge`)
            } : undefined
        });

        this.updatePlayerViews(true);
        this.updateCupIcons(true);
        this.updateTitle();

        cleverapps.focusManager.showControlsWhileFocused("MenuBarGoldItem");

        this.mission.onChangeResults = this.createListener(this.onChangeResults.bind(this));

        this.onChangeResults();

        this.mission.logEvent(Mission.EVENTS.MISSION_WINDOW);
    },

    onShow: function () {
        this._super();

        if (this.showTooltip) {
            this.showTooltip = false;

            const firstCupIcon = Object.values(this.cupIcons).find((icon) => icon.place === 1);
            if (firstCupIcon) {
                firstCupIcon.showTooltip(0.3);
            }
        }
    },

    onChangeResults: function () {
        this.mission.runningCompetition.updateDisplayedResults();

        this.updatePlayerViews();
        this.updateCupIcons();
    },

    onOfferClicked: function () {
        cleverapps.focusManager.currentWindow().close();
        cleverapps.offerManager.showOfferWindow(this.offer);
    },

    createTimer: function () {
        if (this.timer) {
            this.timer.removeFromParent();
            delete this.timer;
        }

        const styles = cleverapps.styles.SnailFeastWindow;

        const font = cleverapps.styles.FONTS.SNAIL_FEAST_WINDOW_TIMER_TEXT;
        let timer;

        if (this.mission.isRunning()) {
            let timeLeft = this.mission.getTimeLeft();
            if (timeLeft > 0) {
                timeLeft = new cleverapps.CountDown(timeLeft, {
                    onFinish: () => {
                        this.createTimer();
                        this.updateTitle();
                    }
                });
            }

            timer = new cleverapps.CountDownView(timeLeft, { font }, {
                onSetTimeDebug: (time) => {
                    MissionsTool.setTimeLeft(this.mission, time);
                }
            });
        }

        if (!timer) {
            return;
        }

        this.timer = timer;

        timer.setAlignment(styles.timer);
        this.backgroundSpine.addChild(timer);
    },

    updateTitle: function () {
        const styles = cleverapps.styles.SnailFeastWindow;
        const title = this.title;

        const message = this.mission.isRunning() ? "SnailFeastWindow.title" : "SnailFeastWindow.finished";

        title.setString(Messages.get(message));
        title.setFont(cleverapps.styles.FONTS.SNAIL_FEAST_WINDOW_MAIN_TITLE_TEXT);

        title.setAlignment(styles.mainTitle);
        title.fitTo(styles.mainTitle.width, styles.mainTitle.height);
    },

    createHelpButton: function () {
        const helpButton = new cleverapps.UI.HelpButton({
            type: {
                button_png: bundles[this.bundleName].frames.help_button_png,
                button_on_png: bundles[this.bundleName].frames.help_button_on_png
            },
            callback: () => {
                GuideWindow.createMissionRulesWindow(this.mission);
            }
        });
        helpButton.setAnchorPoint(0.5, 0.5);
        return helpButton;
    },

    createContent: function () {
        const styles = cleverapps.styles.SnailFeastWindow;

        const stage = this.mission.details.stage || 0;

        const jsons = bundles[this.bundleName].jsons;
        const json = cleverapps.resolution.isVertical() && jsons[`race_window_stage${stage}_vertical`]
            ? jsons[`race_window_stage${stage}_vertical`] : jsons[`race_window_stage${stage}`];

        const background = this.backgroundSpine = new cleverapps.Spine(json);

        if (background.hasAnimation("open")) {
            background.setAnimationAndIdleAfter("open", "idle");
        } else {
            background.setAnimation(0, "idle", true);
        }

        const closeSlot = background.hasSlot("slot_close") && background.getSlot("slot_close");

        const title = this.title = cleverapps.UI.generateOnlyText(
            "",
            cleverapps.styles.FONTS.SNAIL_FEAST_WINDOW_MAIN_TITLE_TEXT
        );
        title.setAnchorPoint(0.5, 0.5);

        background.addChild(this.title);

        const helpButton = this.createHelpButton();
        helpButton.setAlignment(styles.helpButton);
        background.addChild(helpButton);

        if (closeSlot) {
            const closeButton = this.slotCloseButton = new CloseRoundButton({
                onClicked: this.close.bind(this),
                styles: styles.closeButton
            });
            closeSlot.addChild(closeButton);
        }

        this.createRacetrack();
        this.createTimer();

        return background;
    },

    calcMaxResult: function () {
        if (this.mission.runningCompetition && this.mission.runningCompetition.options.algo.maxResult) {
            return this.mission.runningCompetition.options.algo.maxResult;
        }

        const sum = this.mission.runningCompetition.getResults().reduce((acc, row) => acc + row.amount, 0);
        return Math.max(sum, 100);
    },

    createRacetrack: function () {
        const styles = cleverapps.styles.SnailFeastWindow;

        const rows = this.mission.runningCompetition.getDisplayedResults();

        this.rowIndexes = rows.reduce((acc, row, index) => {
            acc[row.id] = index;
            return acc;
        }, {});

        const avatars = rows.map((row, index) => this.createAvatar(row, index));

        const avatarsLayout = new cleverapps.Layout(avatars, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.avatars.margin
        });
        avatarsLayout.setAlignment(styles.avatars);
        this.backgroundSpine.addChild(avatarsLayout);

        const lanes = this.lanes = rows.map(() => this.createLane());

        const racetrack = new cleverapps.Layout(lanes, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.racetrack.margin
        });
        racetrack.setAlignment(styles.racetrack);
        this.backgroundSpine.addChild(racetrack);
    },

    createAvatar: function (row) {
        const styles = cleverapps.styles.SnailFeastWindow;

        const frames = bundles[this.bundleName].frames;
        const userid = `${row.id}`;

        const avatar = new cleverapps.UI.Avatar(row.avatar);
        avatar.setAnchorPoint(0, 0.5);

        const background = cleverapps.UI.createScale9Sprite(frames.name_bg);
        background.setContentSize2(styles.name);
        background.setAlignment(styles.name);
        background.setLocalZOrder(2);
        avatar.addChild(background);

        const playerName = row.name || `Player_${userid.slice(-3)}`;

        const text = cleverapps.UI.generateOnlyText(playerName, cleverapps.styles.FONTS.SNAIL_FEAST_AVATAR_TEXT);
        text.fitTo(background.width - 2 * styles.name.padding, background.height);
        text.setAlignment({ align: "center" }, { align: "center" });
        background.addChild(text);

        cleverapps.UI.fitToBox(avatar, { height: styles.avatars.height });

        return avatar;
    },

    removeCupIcon: function (row, silent) {
        const icon = this.cupIcons[row.id];
        delete this.cupIcons[row.id];

        if (icon) {
            icon.remove(silent);
        }
    },

    addCupIcon: function (row, silent) {
        const styles = cleverapps.styles.SnailFeastWindow;

        const rewards = this.mission.getPrizeByPlace(row.place - 1);
        if (!rewards) {
            return;
        }

        const cupIcon = this.cupIcons[row.id] = new SnailFeastWindowCupIcon(this.mission, row);

        this.backgroundSpine.addChild(cupIcon);
        cupIcon.setAlignment(styles.cup.x, cc.Base.GetTargetPosition(cupIcon, this.playerViews[row.id]).y + styles.cup.y);

        cupIcon.show(silent);
    },

    createLane: function () {
        const styles = cleverapps.styles.SnailFeastWindow;

        const lane = new cc.Node();
        lane.setAnchorPoint(0.5, 0.5);
        lane.setContentSize(styles.racetrack);

        return lane;
    },

    updatePlayerViews: function (silent) {
        const oldPlayerViews = this.playerViews || {};

        this.playerViews = {};

        this.mission.runningCompetition.getDisplayedResults().forEach((row, index) => {
            if (index > 5) {
                return;
            }

            const playerView = this.playerViews[row.id] = oldPlayerViews[row.id] || this.createPlayer(row);
            delete oldPlayerViews[row.id];

            if (this.lanes) {
                playerView.replaceParent(this.lanes[index]);
            } else {
                playerView.replaceParent(this.backgroundSpine);
            }

            this.updatePlayerPosition(row, silent);
        });

        Object.values(oldPlayerViews).forEach((view) => {
            view.removeFromParent();
        });
    },

    createPlayer: function (row) {
        const styles = cleverapps.styles.SnailFeastWindow;

        const jsons = bundles[this.bundleName].jsons;
        const json = cleverapps.resolution.isVertical() && jsons.snail_animation_vertical
            ? jsons.snail_animation_vertical : jsons.snail_animation;

        const playerView = new cleverapps.Spine(json);

        if (row.player && playerView.hasSkin("player")) {
            playerView.setSkin("player");
        }

        playerView.setTimeScale(1.2 - row.place * 0.1);
        playerView.setAnimation(0, "animation", true);

        if (row.amount === undefined) {
            row.amount = 0;
            cleverapps.throwAsync(`createPlayer with undefined amount ${JSON.stringify(row)}`);
        }

        const amountText = cleverapps.UI.generateImageText(row.amount, cleverapps.styles.FONTS.SNAIL_FEAST_SCORE_TEXT);
        amountText.setAnchorPoint(0, 0.5);

        const amountWithIcon = new cleverapps.Layout([new cc.Sprite(bundles[this.bundleName].frames.speed), amountText], {
            direction: cleverapps.UI.HORIZONTAL
        });
        playerView.addChild(amountWithIcon);
        playerView.amountText = amountText;

        amountWithIcon.setAlignment(styles.racetrack.amount);

        if (cleverapps.config.debugMode) {
            cleverapps.UI.onClick(playerView, this.onPlayerViewPressed.bind(this, row.id));
        }

        return playerView;
    },

    onPlayerViewPressed: function (id) {
        const competition = this.mission.runningCompetition;
        const row = competition.getDisplayedResultById(id);

        const maxResult = competition.options.algo.maxResult;

        const currScore = row.amount;

        if (maxResult && currScore >= maxResult) {
            return;
        }

        competition.updatePlayerResult(row.id, currScore + 1);
        competition.save();
        if (row.player) {
            this.mission.update(1);
        }
    },

    updatePlayerPosition: function (row, silent) {
        const styles = cleverapps.styles.SnailFeastWindow;

        const view = this.playerViews[row.id];

        view.amountText.setString(row.amount);

        const progress = row.amount / this.calcMaxResult();
        const position = cc.p(progress * styles.racetrack.width, styles.racetrack.snailY);

        view.stopAllActions();

        if (silent) {
            view.setAlignment(position);
            return;
        }

        view.runAction(
            new cc.MoveTo(0.5, position).easing(cc.easeInOut(1.5))
        );
    },

    updateCupIcons: function (silent) {
        for (const row of this.mission.runningCompetition.getDisplayedResults()) {
            const icon = this.cupIcons[row.id];

            if (icon && icon.place === row.place) {
                continue;
            }

            this.removeCupIcon(row, silent);
            this.addCupIcon(row, silent);
        }
    },

    onClose: function () {
        if (this.mission.runningCompetition) {
            this.mission.runningCompetition.updateShownPlace();
        }
        this.mission.updateMissionIcon();
    },

    listBundles: function (mission) {
        return [mission.getWindowBundleName()];
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    SNAIL_FEAST_AVATAR_TEXT: {
        name: "lightstroke",
        size: 35,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },
    SNAIL_FEAST_SCORE_TEXT: {
        name: "lightstroke",
        size: 35,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },
    SNAIL_FEAST_WINDOW_MAIN_TITLE_TEXT: {
        size: 78,
        color: new cc.Color(255, 201, 39, 255),
        stroke: cleverapps.styles.DECORATORS.MISSION_STROKE,
        shadow: cleverapps.styles.DECORATORS.MISSION_SHADOW
    },
    SNAIL_FEAST_WINDOW_TIMER_TEXT: {
        size: 50,
        color: new cc.Color(255, 220, 132, 255),
        stroke: cleverapps.styles.DECORATORS.MISSION_STROKE,
        shadow: cleverapps.styles.DECORATORS.MISSION_SHADOW
    },

    SNAIL_FEAST_WINDOW_LOCATION_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    SNAIL_FEAST_WINDOW_DESCRIPTION_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    }
});

cleverapps.styles.SnailFeastWindow = {
    margin: 20,

    contentPadding: {
        bottom: 0
    },

    mainTitle: {
        x: { align: "center", dx: 20 },
        y: { align: "center", dy: 584 },
        width: 580,
        height: 90
    },

    timer: {
        x: { align: "center", dx: 20 },
        y: { align: "center", dy: 498 }
    },

    helpButton: {
        x: { align: "center", dx: -715 },
        y: { align: "center", dy: 548 }
    },

    avatars: {
        x: { align: "left", dx: 100 },
        y: { align: "top", dy: -175 },
        margin: 40,

        height: 120
    },

    name: {
        x: { align: "center" },
        y: { align: "bottom", dy: -25 },
        width: 210,
        height: 50,
        padding: 10
    },

    racetrack: {
        width: 800,
        height: 120,

        margin: 46,

        x: { align: "center", dx: 50 },
        y: { align: "center", dy: -40 },

        snailY: 84,

        amount: [{
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: -10 }
        }, {
            x: { align: "center", dx: -36 },
            y: { align: "bottom", dy: -10 }
        }, {
            x: { align: "center", dx: -36 },
            y: { align: "bottom", dy: -10 }
        }]
    },

    cup: {
        x: 300,
        y: -10
    },

    window: {
        CloseButton: {
            scale: [0.8, 1, 1],
            x: { align: "right", dx: -234 },
            y: { align: "top", dy: -48 }
        }
    },

    closeButton: {
        scale: [0.7, 1, 1],
        x: { align: "center" },
        y: { align: "center" }
    }
};
